module.exports = __webpack_public_path__ + "img/people.fee02509.png";